import { Component } from '@angular/core'
import { environment } from '../../../../environments/environment'

@Component({
  selector: 'mb-myaccount-navigation',
  templateUrl: './mb-myaccount-navigation.component.html',
  styleUrls: ['./mb-myaccount-navigation.component.scss']
})
export class MbMyaccountNavigationComponent {

  environment = environment
}
